module.exports = __webpack_public_path__ + "img/Zieh.b668b4e2.jpg";